import React from 'react';
import { Card } from 'primereact/card';

const PrivacyPolicyContent = ({ showHeroCards = true }) => {
    return (
        <div>
            {/* Key Highlights - Optional for dashboard version */}
            {showHeroCards && (
                <div className="grid mb-5">
                    <div className="col-12 md:col-6">
                        <Card className="h-full text-center shadow-4 border-round-xl hover:shadow-8 transition-all transition-duration-300">
                            <div className="inline-flex align-items-center justify-content-center mb-3" 
                                 style={{
                                     width: '60px',
                                     height: '60px',
                                     borderRadius: '12px',
                                     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                 }}>
                                <i className="pi pi-lock text-white text-2xl"></i>
                            </div>
                            <h4 className="font-bold mb-2">Data Security</h4>
                            <p className="text-600 m-0">Secured with SSL encryption and security measures</p>
                        </Card>
                    </div>
                    
                    <div className="col-12 md:col-6">
                        <Card className="h-full text-center shadow-4 border-round-xl hover:shadow-8 transition-all transition-duration-300">
                            <div className="inline-flex align-items-center justify-content-center mb-3" 
                                 style={{
                                     width: '60px',
                                     height: '60px',
                                     borderRadius: '12px',
                                     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                 }}>
                                <i className="pi pi-users text-white text-2xl"></i>
                            </div>
                            <h4 className="font-bold mb-2">Your Rights</h4>
                            <p className="text-600 m-0">Full control over your personal data</p>
                        </Card>
                    </div>
                </div>
            )}

            {/* Policy Sections */}
            <div className="grid">
                <div className="col-12">
                    {/* Section 1: Scope */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-blue-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-info-circle text-blue-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">1. Scope</h2>
                        </div>
                        <p className="text-lg text-700 line-height-3">
                            This Policy explains how Interestng collects, uses, stores and shares your information 
                            when you access our website or API services. It applies to all users of our platform
                            and covers all aspects of data handling within our services.
                        </p>
                    </Card>

                    {/* Section 2: What Data We Collect */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-green-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-database text-green-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">2. What Data We Collect</h2>
                        </div>
                        <div className="grid">
                            <div className="col-12 md:col-6">
                                <div className="surface-50 border-round-lg p-3 mb-3">
                                    <h4 className="text-900 mb-2">
                                        <i className="pi pi-user text-primary mr-2"></i>
                                        Contact Data
                                    </h4>
                                    <p className="text-700 m-0">Name, email address, phone number</p>
                                </div>
                            </div>
                            <div className="col-12 md:col-6">
                                <div className="surface-50 border-round-lg p-3 mb-3">
                                    <h4 className="text-900 mb-2">
                                        <i className="pi pi-id-card text-primary mr-2"></i>
                                        KYC Data
                                    </h4>
                                    <p className="text-700 m-0">Know Your Customer verification information</p>
                                </div>
                            </div>
                            <div className="col-12 md:col-6">
                                <div className="surface-50 border-round-lg p-3 mb-3">
                                    <h4 className="text-900 mb-2">
                                        <i className="pi pi-wallet text-primary mr-2"></i>
                                        Financial Data
                                    </h4>
                                    <p className="text-700 m-0">Loan-related financial information</p>
                                </div>
                            </div>
                            <div className="col-12 md:col-6">
                                <div className="surface-50 border-round-lg p-3 mb-3">
                                    <h4 className="text-900 mb-2">
                                        <i className="pi pi-desktop text-primary mr-2"></i>
                                        Technical Data
                                    </h4>
                                    <p className="text-700 m-0">IP address, browser user-agent, cookies</p>
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Section 3: Lawful Bases */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-purple-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-shield text-purple-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">3. Lawful Bases</h2>
                        </div>
                        <p className="text-lg text-700 mb-4">We process personal data based on:</p>
                        <div className="grid">
                            <div className="col-12 lg:col-4">
                                <div className="text-center p-4">
                                    <i className="pi pi-file-edit text-4xl text-primary mb-3"></i>
                                    <h4 className="font-bold mb-2">Contract</h4>
                                    <p className="text-700">To deliver SaaS services as agreed</p>
                                </div>
                            </div>
                            <div className="col-12 lg:col-4">
                                <div className="text-center p-4">
                                    <i className="pi pi-chart-line text-4xl text-primary mb-3"></i>
                                    <h4 className="font-bold mb-2">Legitimate Interest</h4>
                                    <p className="text-700">For fraud prevention and analytics</p>
                                </div>
                            </div>
                            <div className="col-12 lg:col-4">
                                <div className="text-center p-4">
                                    <i className="pi pi-check-square text-4xl text-primary mb-3"></i>
                                    <h4 className="font-bold mb-2">Consent</h4>
                                    <p className="text-700">For marketing and optional extras</p>
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Section 4: How We Use Data */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-orange-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-cog text-orange-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">4. How We Use Data</h2>
                        </div>
                        <div className="grid">
                            <div className="col-12 md:col-6 lg:col-4">
                                <div className="flex align-items-start mb-3">
                                    <i className="pi pi-check text-green-500 mr-2 mt-1"></i>
                                    <span className="text-lg text-700">Account creation and authentication</span>
                                </div>
                            </div>
                            <div className="col-12 md:col-6 lg:col-4">
                                <div className="flex align-items-start mb-3">
                                    <i className="pi pi-check text-green-500 mr-2 mt-1"></i>
                                    <span className="text-lg text-700">Verifying identity</span>
                                </div>
                            </div>
                            <div className="col-12 md:col-6 lg:col-4">
                                <div className="flex align-items-start mb-3">
                                    <i className="pi pi-check text-green-500 mr-2 mt-1"></i>
                                    <span className="text-lg text-700">Generating credit reports</span>
                                </div>
                            </div>
                            <div className="col-12 md:col-6 lg:col-4">
                                <div className="flex align-items-start mb-3">
                                    <i className="pi pi-check text-green-500 mr-2 mt-1"></i>
                                    <span className="text-lg text-700">Customer support</span>
                                </div>
                            </div>
                            <div className="col-12 md:col-6 lg:col-4">
                                <div className="flex align-items-start mb-3">
                                    <i className="pi pi-check text-green-500 mr-2 mt-1"></i>
                                    <span className="text-lg text-700">Service improvement</span>
                                </div>
                            </div>
                            <div className="col-12 md:col-6 lg:col-4">
                                <div className="flex align-items-start mb-3">
                                    <i className="pi pi-check text-green-500 mr-2 mt-1"></i>
                                    <span className="text-lg text-700">Regulatory compliance</span>
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Section 5: Storage & Transfers */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-cyan-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-server text-cyan-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">5. Storage & Transfers</h2>
                        </div>
                        <div className="grid">
                            <div className="col-12 md:col-6">
                                <div className="surface-50 border-round-lg p-4">
                                    <h4 className="font-bold text-900 mb-3">
                                        <i className="pi pi-lock text-primary mr-2"></i>
                                        Secure Storage
                                    </h4>
                                    <p className="text-lg text-700 m-0">
                                        Data stored on secure servers in Indian region with enterprise-grade encryption
                                    </p>
                                </div>
                            </div>
                            <div className="col-12 md:col-6">
                                <div className="surface-50 border-round-lg p-4">
                                    <h4 className="font-bold text-900 mb-3">
                                        <i className="pi pi-globe text-primary mr-2"></i>
                                        Cross-border Transfers
                                    </h4>
                                    <p className="text-lg text-700 m-0">
                                        Transfers occur under standard contractual safeguards when necessary
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Section 6: Sharing */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-indigo-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-share-alt text-indigo-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">6. Data Sharing</h2>
                        </div>
                        <p className="text-lg text-700 mb-4">We share data only with:</p>
                        <div className="grid">
                            <div className="col-12 md:col-4">
                                <div className="text-center p-4 surface-50 border-round-lg">
                                    <i className="pi pi-credit-card text-3xl text-primary mb-3"></i>
                                    <h4 className="font-bold mb-2">Razorpay</h4>
                                    <p className="text-700 m-0">For secure payment processing</p>
                                </div>
                            </div>
                            <div className="col-12 md:col-4">
                                <div className="text-center p-4 surface-50 border-round-lg">
                                    <i className="pi pi-verified text-3xl text-primary mb-3"></i>
                                    <h4 className="font-bold mb-2">Credit Bureaus</h4>
                                    <p className="text-700 m-0">For verification services</p>
                                </div>
                            </div>
                            <div className="col-12 md:col-4">
                                <div className="text-center p-4 surface-50 border-round-lg">
                                    <i className="pi pi-building text-3xl text-primary mb-3"></i>
                                    <h4 className="font-bold mb-2">Banks and NBFC</h4>
                                    <p className="text-700 m-0">For loan processing</p>
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Section 7: Your Rights */}
                    <Card className="mb-4 shadow-2 border-round-xl" style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)' }}>
                        <div className="flex align-items-center mb-4">
                            <div className="bg-white p-3 border-round-xl mr-3">
                                <i className="pi pi-users text-primary text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">7. Your Rights</h2>
                        </div>
                        <p className="text-lg text-700 mb-4">As a user, you have the right to:</p>
                        <div className="grid">
                            <div className="col-12 md:col-6 lg:col-3">
                                <div className="bg-white border-round-lg p-4 text-center h-full">
                                    <i className="pi pi-eye text-4xl text-blue-500 mb-3"></i>
                                    <h4 className="font-bold mb-2">Access</h4>
                                    <p className="text-700 m-0">Request a copy of your personal data</p>
                                </div>
                            </div>
                            <div className="col-12 md:col-6 lg:col-3">
                                <div className="bg-white border-round-lg p-4 text-center h-full">
                                    <i className="pi pi-pencil text-4xl text-green-500 mb-3"></i>
                                    <h4 className="font-bold mb-2">Correction</h4>
                                    <p className="text-700 m-0">Update or correct inaccurate data</p>
                                </div>
                            </div>
                            <div className="col-12 md:col-6 lg:col-3">
                                <div className="bg-white border-round-lg p-4 text-center h-full">
                                    <i className="pi pi-trash text-4xl text-orange-500 mb-3"></i>
                                    <h4 className="font-bold mb-2">Erasure</h4>
                                    <p className="text-700 m-0">Request deletion of your data</p>
                                </div>
                            </div>
                            <div className="col-12 md:col-6 lg:col-3">
                                <div className="bg-white border-round-lg p-4 text-center h-full">
                                    <i className="pi pi-download text-4xl text-purple-500 mb-3"></i>
                                    <h4 className="font-bold mb-2">Portability</h4>
                                    <p className="text-700 m-0">Receive data in portable format</p>
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Section 8: Cookies */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-pink-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-globe text-pink-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">8. Cookies</h2>
                        </div>
                        <div className="grid">
                            <div className="col-12 md:col-6">
                                <div className="flex align-items-start mb-3">
                                    <i className="pi pi-key text-primary text-xl mr-3 mt-1"></i>
                                    <div>
                                        <h4 className="font-bold mb-2">Essential Cookies</h4>
                                        <p className="text-700 m-0">Required for login sessions and basic functionality</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 md:col-6">
                                <div className="flex align-items-start mb-3">
                                    <i className="pi pi-chart-bar text-primary text-xl mr-3 mt-1"></i>
                                    <div>
                                        <h4 className="font-bold mb-2">Analytics Cookies</h4>
                                        <p className="text-700 m-0">Google Analytics 4 with IP anonymization</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Section 9: Contact */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-teal-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-envelope text-teal-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">9. Contact Us</h2>
                        </div>
                        <div className="grid">
                            <div className="col-12 md:col-6">
                                <Card className="surface-50 h-full">
                                    <h4 className="font-bold mb-3">
                                        <i className="pi pi-user-edit text-primary mr-2"></i>
                                        Privacy Officer
                                    </h4>
                                    <p className="text-lg text-700 line-height-3">
                                        Interestng<br />
                                        Hireka Services Pvt. Ltd.<br />
                                        949, 21st Main Road<br />
                                        Banashankari 2nd Stage<br />
                                        BENGALURU - 560070
                                    </p>
                                </Card>
                            </div>
                            <div className="col-12 md:col-6">
                                <Card className="surface-50 h-full">
                                    <h4 className="font-bold mb-3">
                                        <i className="pi pi-phone text-primary mr-2"></i>
                                        Contact Details
                                    </h4>
                                    <p className="text-lg text-700 line-height-3">
                                        <i className="pi pi-envelope text-primary mr-2"></i>
                                        tech@interestng.com<br />
                                        <i className="pi pi-clock text-primary mr-2"></i>
                                        Mon-Sat 9AM-7PM IST
                                    </p>
                                </Card>
                            </div>
                        </div>
                    </Card>

                    {/* Section 10: Policy Updates */}
                    <Card className="shadow-2 border-round-xl" style={{ 
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
                    }}>
                        <div className="text-center text-white">
                            <i className="pi pi-refresh text-5xl mb-4 opacity-90"></i>
                            <h2 className="text-3xl font-bold mb-3">10. Policy Updates</h2>
                            <p className="text-lg line-height-3 opacity-95" style={{ maxWidth: '800px', margin: '0 auto' }}>
                                This policy may be amended periodically. Material changes will be notified via email to registered users.
                                Please review this Privacy Policy regularly to stay informed about how we protect your information.
                            </p>
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicyContent;